import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HomepageComponent} from './homepage/homepage.component';
import {LocalizeRouterModule} from '@gilsdav/ngx-translate-router';
import {PrivacyComponent} from './privacy/privacy.component';
import {CookiesComponent} from './cookies/cookies.component';
import {Paths, SemiPath} from '../../../config/config';
import {SearchComponent} from './search/search.component';
import {NotFoundComponent} from './not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
    data: {
      page: Paths.Homepage
    }
  },
  {
    path: SemiPath.Privacy,
    component: PrivacyComponent,
    data: {
      page: Paths.Privacy
    }
  },
  {
    path: SemiPath.Cookies,
    component: CookiesComponent,
    data: {
      page: Paths.Cookies
    }
  },
  {
    path: `${SemiPath.Search}/:term`,
    component: SearchComponent
  },
  {
    path: SemiPath.NotFound,
    component: NotFoundComponent,
    data: {
      page: Paths.Cookies
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), LocalizeRouterModule.forChild(routes)],
  exports: [RouterModule, LocalizeRouterModule]
})
export class RootRoutingModule {
}
